import { Box, BoxProps, Typography } from "@mui/material";
import { ReactElement } from "react";

interface ListItemProps {
  label: string | ReactElement;
  value?: ReactElement;
  disabled?: boolean;
}

export const CloudListItem = ({
  label,
  value,
  disabled,
  ...rest
}: ListItemProps & BoxProps) => {
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        padding: "10px 24px",
        flexDirection: "row",
        alignItems: "center",
        cursor: disabled ? "auto" : "pointer ",
        ":hover": {
          background: disabled ? "auto" : theme.palette.grey[200],
          p: {
            color: disabled ? "auto" : theme.palette.primary.main,
          },
        },
      })}
      {...rest}
    >
      <Typography
        variant="body1"
        sx={{
          display: "flex",
          flex: 1,
        }}
      >
        {label}
      </Typography>
      {value ? (
        <Box
          sx={() => ({
            display: "flex",
            flex: 1,
            justifyContent: "flex-end",
          })}
        >
          {value}
        </Box>
      ) : null}
    </Box>
  );
};
